<template>
  <div>
    <div class="search-con search-con-top">
      <Input clearable placeholder="输入设备号" class="search-input" v-model="param.devicenum"/>
      <Input clearable placeholder="输入保单号" class="search-input" v-model="param.pnum"/>
      <Input clearable placeholder="输入销售单号" class="search-input" v-model="param.salenum"/>
      <Input clearable placeholder="输入操作人" class="search-input" v-model="param.creatorname"/>
      <Select v-model="param.shop4s" filterable style="width:200px;" placeholder="请选择车行名">
        <Option value>全部</Option>
        <Option v-for="item in carServeList" :key="item.id" :value="item.name">{{item.name}}</Option>
      </Select>
      <DatePicker
        v-model="param.dstarttime"
        type="date"
        placeholder="输入作废起始时间"
        format="yyyy-MM-dd"
        class="search-input"
          style="width: 200px"
      ></DatePicker>
      <DatePicker
        v-model="param.dendtime"
        type="date"
        placeholder="输入作废中止时间"
        format="yyyy-MM-dd"
        class="search-input"
          style="width: 200px"
      ></DatePicker>
      <Button @click="getList" class="search-btn" type="primary"><Icon type="search"/>&nbsp;&nbsp;查询</Button>
      <Button @click="editInfo(false)" class="search-btn" type="primary"><Icon type="search"/>&nbsp;&nbsp;重置</Button>
    </div>
    <Modal v-model="editModalShow" @on-ok="deleteInfo()" scrollable title="编辑">
      <Form ref="deleteValidate" :model="deleteValidate" :rules="ruleDeleteValidate" :label-width="80" class="edit-win">
        <FormItem label="原因" prop="reason">
          <Select v-model="deleteValidate.reason" style="width:380px;">
            <Option value="1">退保</Option>
            <Option value="2">车主信息变更</Option>
            <Option value="3">设备信息变更</Option>
            <Option value="4">车辆信息变更</Option>
            <Option value="5">其他</Option>
          </Select>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="deleteValidate.remark" placeholder="请输入备注" style="width: 380px" />
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="renewalModalShow" @on-ok="renewal()" scrollable title="续期">
      <Form ref="deleteValidate" :model="renewalValidate" :rules="ruleRenewalValidate" :label-width="80" class="edit-win">
        <FormItem label="续期时间" prop="date">
          <DatePicker
            v-model="renewalValidate.date"
            type="date"
            placeholder="输入结束日期"
            format="yyyy-MM-dd"
            class="search-input"
              style="width: 380px"
          ></DatePicker>
        </FormItem>
        <FormItem label="意见" prop="opinion">
          <Input v-model="renewalValidate.opinion" placeholder="请输入意见" style="width: 380px" />
        </FormItem>
      </Form>
    </Modal>
    <Table border :columns="columns1" :data="showData.list"></Table>
    <div class="page-con">
      <Page show-total :total="showData.total" :page-size="10" @on-change="chagepage" :current="showData.pageNum" show-elevator class="pull-right" />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      editModalShow: false,  //作废窗口显示
      renewalModalShow: false,  //续期窗口显示
      param: {              //查询条件
        devicenum: '',
        pnum: '',
        customername: '',
        username: '',
        firstbeneficiary: '',
        policystate: '',
        dstarttime: '',
        dendtime: '',
      },
      showData: {           //列表容器
        pageNum: 1
      },
      deleteValidate: {
        id:'',
        reason: '',
        remark: '',
      },
      ruleDeleteValidate: {
        reason: [
          { required: true, message: '不能为空', trigger: 'blur'  }
        ],
        remark: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
      },
      renewalValidate: {
        saleslipid:'',
        date: '',
        opinion: '',
      },
      carServeList: [],
      ruleRenewalValidate: {
        date: [
          { required: true, message: '不能为空', trigger: 'blur'  }
        ],
        opinion: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
      },
      columns1: [           //表头
        {title: '设备号',key: 'devicenum'},
        {title: '保单号',key: 'pnum'},
        {title: '保单金额',key: 'policyamount'},
        {title: '4s店名',key: 'shop4s'},
        {title: '作废时间', align: 'center', key: 'deltime',
          render: (h, params) => {
            return h('div', this.$formatTimeCN(params.row.deltime))
          }
        },
        {title: '作废人',key: 'delman'},
        {title: '作废原因', align: 'center', key: 'reason',
          render: (h, params) => {
            return h('div', this.getReason(params.row.reason))
          }
        },
        {title: '备注',key: 'remark'},
        {title: '车主姓名',key: 'customername'},
        {title: '手机号',key: 'phone'},
        {title: '赔付金额',key: 'compensation'},
        {title: '车牌号码',key: 'frame'},
        {title: '保单开始日期', align: 'center', key: 'pstarttime',
          render: (h, params) => {
            return h('div', this.$formatTimeCN(params.row.pstarttime))
          }
        },
        {title: '保单结束日期', align: 'center', key: 'pendtime',
          render: (h, params) => {
            return h('div', this.$formatTimeCN(params.row.pendtime))
          }
        },
        {title: '录入人',key: 'creator'},
        {title: '第一受益人',key: 'firstbeneficiaryname'},
      ]
    }
  },
  activated() {
    this.getCarServeList();
    this.getList ()
  },
  mounted () {
    this.getCarServeList();
    this.getList ()
  },
  methods: {
    chagepage (current) {
      this.showData.pageNum = current
      this.getList()
    },
    getCarServeList() {
      //获取车行列表
      this.$Loading.start();
      this.$axios.get("/policy/group").then(
        function(response) {
          if (response.data.success) {
            this.carServeList = response.data.data;
            this.$Loading.finish();
          } else {
            this.$Message.error(response.data.errMsg);
            this.$Loading.error();
          }
        }.bind(this)
      );
    },
    getList () {   //获取列表
      this.$Loading.start()
      this.param.dstarttime = this.$formatTimeCN(this.param.dstarttime)
      this.param.dendtime = this.$formatTimeCN(this.param.dendtime)
      this.$axios.get('/salevoidrecord/list/' + this.showData.pageNum+'?devicenum='+this.param.devicenum+
      '&pnum='+this.param.pnum+'&customername='+this.param.customername+
      '&username='+this.param.username+'&firstbeneficiary='+this.param.firstbeneficiary+
      '&policystate='+this.param.policystate+'&pstarttime='+this.param.pstarttime+'&pendtime='+this.param.pendtime)
      .then(function (response) {
        if (response.data.success) {
          this.showData = response.data.data
          this.$Loading.finish()
        } else {
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
      }.bind(this))
    },
    getReason(type) {
      if(type == 1) {
        return '退保'
      } else if(type == 2) {
        return '车主信息变更'
      } else if(type == 3) {
        return '设备信息变更'
      } else if(type == 4) {
        return '车辆信息变更'
      } else if(type == 5) {
        return '其他'
      }
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/views/salevoidrecord/list.vue